export class ActionLogicHandler {

	interactionHandler
	dialogueHandler
	actions = {
		//
	}

	uiEventCallback = () => {
	}

	constructor(actions, interactionHandler, dialogueHandler) {
		this.actions = actions
		this.interactionHandler = interactionHandler
		this.dialogueHandler = dialogueHandler
		this._registerEventListeners()
	}

	_registerEventListeners() {
		window.addEventListener('interaction-success', (e) => this.onInteractionSuccess(e))
		window.addEventListener('interaction-error', (e) => this.onInteractionError(e))
	}

	reset() {
		this.actions = {}
		window.removeEventListener('interaction-success', (e) => this.onInteractionSuccess(e))
		window.removeEventListener('interaction-error', (e) => this.onInteractionError(e))
	}

	registerActions(actions = {}) {
		Object.assign(this.actions, actions)
	}

	setUIEventCallback(callback) {
		this.uiEventCallback = callback
	}

	onInteractionSuccess(e) {
		console.log("ActionLogicHandler::onInteractionSuccess", e)
		if (!e.detail.interaction.on_success)
			return

		this._fireActionInteraction(e.detail.interaction.on_success, e.detail.metadata)
	}

	onInteractionError(e) {
		if (!e.detail.interaction.on_error)
			return

		this._fireActionInteraction(e.detail.interaction.on_error, e.detail.metadata)
	}

	_fireActionInteraction(actionName, data) {
		const action = this.actions[actionName]
		if (!action) {
			console.warn("ActionLogicHandler err - missing action", actionName)
			return
		}

		if (this.dialogueHandler.isActive()) {
			console.log("Dialogue handler active, enriching metadata", this.dialogueHandler.getCurrentTree().getMetadata())
			data = Object.assign(this.dialogueHandler.getCurrentTree().getMetadata(), data)
		}

		const payload = {
			detail: {
				interaction: action,
				data: data
			}
		}


		this.uiEventCallback(payload)
		this.interactionHandler.onInteractionFire(payload)
	}
}